import { AssignmentTurnedIn as AssignmentTurnedInIcon, Cancel as CancelIcon, MenuBook as MenuBookIcon, Schedule as ScheduleIcon, } from '@mui/icons-material'
import { Avatar, Box, Breadcrumbs, Container, Divider, Grid, LinearProgress, Link, List, ListItem, ListItemAvatar, ListItemIcon, ListItemText, Typography } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import Big from 'big.js'
import React from 'react'
import { Route, Link as RouterLink, Switch, useParams, useRouteMatch, withRouter } from "react-router-dom"
import Heading from '../components/Heading'
import { withAppContext } from '../context/AppContextProvider'

const styles = (theme) => ({
    loading: {
        marginTop: theme.spacing(2),
    },
    marginAbove: {
        marginTop: theme.spacing(2),
    },
    breadcrumbs: {
        marginTop: theme.spacing(2),
    },
    box: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    sumListItemText: {
        flex: 'none',
    },
})

class Orders extends React.Component {
    state = {
        waits: 1,
        saving: false,
        orders: [],
        products: [],
        packages: [],
    }

    async componentDidMount() {
        await this.getOrders()

        this.setState({
            waits: this.state.waits - 1,
        })
    }

    getOrders = async () => {
        await this.setState({
            waits: this.state.waits + 1,
        })

        try {
            const { orders, products, packages } = await this.props.socket.send('orders', {
                step: 'getOrders',
            })

            await this.setState({
                orders,
                products,
                packages,
            })

        } catch (err) {
            this.props.showError(err)
        }

        await this.setState({
            waits: this.state.waits - 1,
        })
    }

    render() {
        const { classes, history, match } = this.props
        const { orders, products, packages, waits } = this.state
        const url = match.path

        return (
            <Container maxWidth="sm">
                <Heading icon={<MenuBookIcon />}>
                    My Orders
                </Heading>
                <Grid container justifyContent="space-between" alignItems="flex-end">
                    <Grid className={classes.breadcrumbs} item xs={12} sm={7} md={9} lg={9}>
                        <Switch>
                            <Route path={`${url}`} exact>
                                <Breadcrumbs aria-label="breadcrumb">
                                    <Link component={RouterLink} to={`${url}`} color="textPrimary" underline="hover">
                                        Orders
                                    </Link>
                                </Breadcrumbs>
                            </Route>
                            <Route path={`${url}/order-:orderId`}>
                                <Breadcrumbs aria-label="breadcrumb">
                                    <Link component={RouterLink} to={`${url}`} color="inherit" underline="hover">
                                        Orders
                                    </Link>
                                    {waits == 0 &&
                                        <SelectedOrderLink />
                                    }
                                </Breadcrumbs>
                            </Route>
                        </Switch>
                    </Grid>
                </Grid>
                {waits > 0 &&
                    <LinearProgress className={classes.loading} />
                }
                {waits == 0 &&
                    <Switch>
                        <Route path={`${url}/`} exact>
                            <List>
                                <OrderList
                                    classes={classes}
                                    orders={orders}
                                    products={products}
                                    packages={packages}
                                    onOrderSelect={(orderId) => {
                                        history.push(`${url}/order-${orderId}`)
                                    }}
                                    />
                            </List>
                        </Route>
                        <Route path={`${url}/order-:orderId`}>
                            <OrderContents
                                classes={classes}
                                orders={orders}
                                products={products}
                                packages={packages}
                            />
                        </Route>
                    </Switch>
                }
            </Container>
        )
    }
}

export default withAppContext(withRouter(withStyles(styles, { withTheme: true })(Orders)))

function SelectedOrderLink(props) {
    const { url } = useRouteMatch()
    const { orderId } = useParams()

    return (
        <Link component={RouterLink} to={`${url}`} color="textPrimary" underline="hover">
            Order # {orderId}
        </Link>
    )
}

function OrderList(props) {
    const { orders } = props

    if (!orders.length) {
        return (
            <Box>
                <Typography>You have no order history.</Typography>
            </Box>
        )
    }

    return orders.map(order => {
        const itemCount = order.lines.reduce((sum, line) => {
            return sum + parseInt(line.product_quantity)
        }, 0)

        const packageCount = order.packages.length

        return (
            <ListItem key={order.id} button onClick={props.handleOrderClick}>
                <ListItemIcon>
                    {order.status == 'Completed' &&
                        <AssignmentTurnedInIcon />
                    }
                    {order.status == 'Processed' &&
                        <AssignmentTurnedInIcon />
                    }
                    {order.status == 'Not-Processed' &&
                        <ScheduleIcon />
                    }
                    {order.status == 'Cancelled' &&
                        <CancelIcon />
                    }
                </ListItemIcon>
                <ListItemText
                    primary={order.date_and_time_formatted}
                    secondary={`${itemCount + packageCount} items, $${Big(order.total).toFixed(2)}`}
                    onClick={() => { props.onOrderSelect(order.id) }}
                />
            </ListItem>
        )
    })
}

function OrderContents(props) {
    const { orderId } = useParams()
    const { classes, orders, products, packages } = props

    const order = orders.find(order => order.id == orderId)

    return <>
        <Box className={classes.box}>
            <Typography className={classes.marginAbove}>
                Date: {order.date_and_time_formatted}
            </Typography>
            <Typography className={classes.marginAbove}>
                Status: {order.status == 'Not-Processed' ? 'Submitted to clinic' : order.status}
            </Typography>
            <Typography className={classes.marginAbove}>
                Tracking: {order.shipping_label ? <Link href={order.shipping_label.tracking_url} color="textPrimary" underline="hover">Click here to track shipment</Link> : 'N/A'}
            </Typography>
            <Divider className={classes.marginAbove} />
        </Box>
        <List>
            {order.lines.map(line => {
                const product = products.find(product => line.product_id == product.id)

                return (
                    <ListItem key={line.id}>
                        <ListItemAvatar>
                            <Avatar src={product?.image_url || window.location.origin + `/product_imgs/${line.upc_code}.png`} alt={line.product_name_cc} />
                        </ListItemAvatar>
                        <ListItemText
                            primary={line.product_name_cc}
                            secondary={`${line.product_quantity} x $${line.product_price}`}
                        />
                    </ListItem>
                )
            })}

            {order.packages.map(package_line => {
                const pkg = packages.find(pkg => package_line.package_id == pkg.id)

                // TODO Stu to customize
                return (
                    <ListItem key={package_line.id}>
                        <ListItemAvatar>
                            <Avatar src={pkg?.image_url || package_line.package_name_cc} alt={package_line.package_name_cc} />
                        </ListItemAvatar>
                        <ListItemText
                            primary={package_line.package_name_cc}
                            secondary={<>
                                {package_line.package_price == package_line.package_paid_on_purchase &&
                                    `Package price: $${package_line.package_price}`
                                }
                                {package_line.package_price != package_line.package_paid_on_purchase && <>
                                    {`Package price: $${package_line.package_price}`}<br />
                                    {`Initial payment: $${package_line.package_paid_on_purchase}`}
                                </>}
                            </>}
                        />
                    </ListItem>
                )
            })}
        </List>
        <Box className={classes.box}>
            <Divider />
            <Grid className={classes.marginAbove} container justifyContent="space-between">
                <ListItemText className={classes.sumListItemText} primary="Subtotal" secondary={`$${Big(order.subtotal).toFixed(2)}`} />
                <ListItemText className={classes.sumListItemText} primary="Tax" secondary={`$${Big(order.tax).toFixed(2)}`} />
                <ListItemText className={classes.sumListItemText} primary="Shipping" secondary={`$${Big(order.shipping).toFixed(2)}`} />
                <ListItemText className={classes.sumListItemText} primary="Total" secondary={`$${Big(order.total).toFixed(2)}`} />
            </Grid>
        </Box>
    </>
}
